import MultiColorTextLink from './MultiColorTextLink';


export default MultiColorTextLink; 